module.exports = __webpack_public_path__ + "img/DK61092919.7bb7a914.png";